export class PasswordToken {
    password:string;
    constructor(){
        this.password="";
    }
}
